import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControlLabel, Icon, Radio } from '@emburse/embark-core';
import { OptionCardLabelStyled } from '../../../../../../views/CreateExpenseReport/utils/styles';
function BlankReportForm({ value, iconUrl, labelText, disabled }) {
    return (_jsx(FormControlLabel, { value: value, control: _jsx(Radio, { color: "primary", value: value }), label: _jsxs(OptionCardLabelStyled, { children: [_jsx(Icon, { iconUrl: iconUrl }), labelText] }), disabled: disabled }));
}
export default BlankReportForm;
